import { Button, Col, Row, Table } from "antd";
import { PlusCircle } from "lucide-react";

import useSubscriptionPlans from "./useSubscriptionPlans";
import SubscriptionPlanModal from "../../components/modals/subscriptionPlan";
import Permission from "../../components/general/permission/permission";

function SubscriptionPlans() {
  const {
    data,
    form,
    handleOk,
    handleCancel,
    loading,
    onTableChange,
    tableColumns,
    tableParams,
    total,
    subscriptionPlanModal,
  } = useSubscriptionPlans();

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "16px",
        }}
      >
        <h2 style={{ margin: 0 }}>Planes de suscripción</h2>
        <Permission requiredPermission={"ui:subscription-plans:create"}>
          <Button
            type="primary"
            id={"add-plan"}
            onClick={subscriptionPlanModal.openModal}
            icon={<PlusCircle size={16} />}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              borderRadius: "8px",
              background: "#81BC3D",
              borderColor: "#81BC3D",
            }}
          >
            Agregar plan
          </Button>
        </Permission>
      </div>

      <Row gutter={24}>
        <Col span={24}>
          <Table
            loading={loading}
            dataSource={data}
            columns={tableColumns}
            pagination={{
              ...tableParams.pagination,
              total,
            }}
            onChange={onTableChange}
            rowKey={(record) => record.id}
            scroll={{ x: 900 }}
            style={{ borderRadius: "8px" }}
          />
        </Col>
      </Row>

      <SubscriptionPlanModal
        isModalOpen={subscriptionPlanModal.isModalOpen}
        handleOk={handleOk}
        handleCancel={handleCancel}
        form={form}
        loading={subscriptionPlanModal.isLoading}
        editing={subscriptionPlanModal.editing}
      />
    </div>
  );
}

export default SubscriptionPlans;
